<template>
  <div class="template">
    <div class="search">
      <div>
        <Input
          v-model="search.search"
          placeholder="关键字"
          style="width: 310px; margin-right: 10px"
          icon="ios-search"
        ></Input>
        <Button style="width: 90px" type="primary" icon="ios-search" @click="searchFn">搜索</Button>
      </div>
    </div>
    <div class="filter">
      <div class="filter-item">
        <span class="title">状态</span>
        <Select v-model="search.status" style="width: 200px" placeholder="请选择状态">
          <Option label="全部" value=""></Option>
          <Option label="驳回未通过" value="2"></Option>
          <Option label="入会成功" value="3"></Option>
        </Select>
      </div>
      <div class="filter-item">
        <Button type="primary" style="width: 90px" @click="searchFn">搜索</Button>
        <Button style="margin-left: 10px; width: 90px" @click="clearFn">清空</Button>
      </div>
    </div>
    <div class="table">
      <Table border :columns="diyData.columns" :data="apiData.tableList">
        <template slot="footer">
          <Page
            :total="apiData.total"
            show-total
            :page-size="apiData.per_page"
            :current="search.page"
            class-name="footer-page"
            @on-change="pageChange"
          ></Page>
        </template>
      </Table>
    </div>
    <!-- 审核 -->
    <inspectModal v-model="diyDom.showInspect" :type="3" :id="diyData.id" @on-success="getTableList"></inspectModal>
    <!-- 编辑 -->
    <edit v-model="diyDom.showEdit" :id="diyData.id" :is-edit="true" @on-success="getTableList"></edit>

    <!-- 审核记录 -->
    <Modal v-model="diyDom.showRecord" title="审核记录" footer-hide>
      <h2 style="margin: 0 0 10px 40px">{{ diyData.examineText }}</h2>
      <Steps :current="diyData.examineLog.length - 1" direction="vertical">
        <Step v-for="(item, index) in diyData.examineLog" :key="index" :title="`审核人：${item.admin_name}`">
          <div slot="content">
            <div>审核意见：{{ item.remark }}</div>
            <div>审核时间：{{ item.created_at }}</div>
          </div>
        </Step>
      </Steps>
    </Modal>
  </div>
</template>

<script>
  import * as apiMember from '@/api/member'
  import downloadBlob from '@/utils/downloadBlob'
  import inspectModal from '../inspect-modal.vue'
  import edit from './edit.vue'
  export default {
    name: 'tableList',
    components: {
      inspectModal,
      edit,
    },
    data() {
      return {
        query: {},
        search: {
          search: '',
          status: '',
          page: 1,
        },
        diyDom: {
          showInspect: false, // 审核弹窗
          showRecord: false, // 审核记录弹窗
          showEdit: false, // 编辑
        },
        diyData: {
          id: '',
          examineLog: [], // 审核记录
          examineText: '', // 审核意见
          columns: [
            {
              title: 'ID',
              width: 90,
              fixed: 'left',
              render: (h, params) => {
                return h('div', params.index + 1)
              },
            },
            {
              width: 140,
              fixed: 'left',
              title: '姓名',
              key: 'name',
            },
            {
              width: 140,
              title: '性别',
              key: 'gender_lab',
            },
            {
              width: 180,
              title: '身份证',
              key: 'card',
            },
            {
              width: 140,
              title: '电话',
              key: 'mobile',
            },
            {
              width: 140,
              title: '微信',
              key: 'wechat',
            },
            {
              width: 140,
              title: '政治面貌',
              key: 'political_outlook_lab',
            },
            {
              width: 160,
              title: '所在地',
              key: 'address',
              render: (h, params) => {
                return h('div', params.row.address.length ? params.row.address.join('-') : '')
              },
            },
            {
              width: 140,
              title: '学历',
              key: 'education',
            },
            {
              width: 140,
              title: '工作单位/机构',
              key: 'unit',
            },
            {
              width: 140,
              title: '职位',
              key: 'position',
            },
            {
              width: 140,
              title: '舞蹈种类',
              key: 'dance_category',
            },
            {
              width: 200,
              title: '个人履历',
              key: 'resume',
            },
            {
              width: 140,
              title: '形象照',
              key: 'image_photo_url',
              render: (h, params) => {
                return h(
                  'a',
                  {
                    style: {
                      display: params.row.image_photo_url ? 'inline' : 'none',
                    },
                    attrs: {
                      href: params.row.image_photo_url,
                      target: '_blank',
                    },
                  },
                  '查看'
                )
              },
            },
            {
              width: 140,
              title: '身份证正面',
              key: 'card_front_photo_url',
              render: (h, params) => {
                return h(
                  'a',
                  {
                    style: {
                      display: params.row.card_front_photo_url ? 'inline' : 'none',
                    },
                    attrs: {
                      href: params.row.card_front_photo_url,
                      target: '_blank',
                    },
                  },
                  '查看'
                )
              },
            },
            {
              width: 140,
              title: '身份证反面',
              key: 'card_opposite_photo_url',
              render: (h, params) => {
                return h(
                  'a',
                  {
                    style: {
                      display: params.row.card_opposite_photo_url ? 'inline' : 'none',
                    },
                    attrs: {
                      href: params.row.card_opposite_photo_url,
                      target: '_blank',
                    },
                  },
                  '查看'
                )
              },
            },
            {
              width: 140,
              title: '审核状态',
              key: 'status_lab',
            },
            {
              width: 140,
              title: '审核意见',
              key: 'remark',
            },
            {
              title: '操作',
              fixed: 'right',
              width: 230,
              render: (h, params) => {
                return h('div', [
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                        display: params.row.status == 3 ? 'none' : 'inline',
                      },
                      on: {
                        click: () => {
                          this.diyData.id = params.row.id
                          this.diyDom.showInspect = true
                        },
                      },
                    },
                    '审核'
                  ),
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                      },
                      on: {
                        click: () => {
                          this.diyData.id = params.row.id
                          this.diyDom.showEdit = true
                        },
                      },
                    },
                    '编辑'
                  ),
                  h(
                    'a',
                    {
                      style: {
                        marginRight: '10px',
                        color: '#2D8cF0',
                        display: params.row.examine_log.length > 0 ? 'inline' : 'none',
                      },
                      on: {
                        click: () => {
                          this.diyData.examineLog = params.row.examine_log
                          this.diyData.examineText = params.row.remark
                          this.diyDom.showRecord = true
                        },
                      },
                    },
                    '审核记录'
                  ),
                  h(
                    'Dropdown',
                    {
                      props: {
                        transfer: true,
                      },
                      on: {
                        'on-click': e => {
                          this.downloadFn(e,params.row.id)
                        },
                      },
                    },
                    [
                      h('a', '下载'),
                      h(
                        'DropdownMenu',
                        {
                          slot: 'list',
                        },
                        [
                          h(
                            'DropdownItem',
                            {
                              props: {
                                name: 1,
                              },
                            },
                            '下载附件'
                          ),
                          h(
                            'DropdownItem',
                            {
                              props: {
                                name: 2,
                              },
                            },
                            '下载内容'
                          ),
                        ]
                      ),
                    ]
                  ),
                  h('a',{
                    style:{
                      color:'red',
                      marginLeft:'10px'
                    },
                    on:{
                      click:() => {
                        this.$Modal.confirm({
                          title:'提示',
                          content:'请确认是否删除当前数据？',
                          onOk:() => {
                            apiMember.apiPositionDelete(params.row.id).then(()=>{
                              this.$Message.success('删除成功')
                              this.getTableList()
                            })
                          }
                        })
                      }
                    }
                  },'删除')
                ])
              },
            },
          ],
        },
        apiData: {
          total: 0,
          per_page: 0,
          tableList: [],
        },
      }
    },
    methods: {
      // 获取表格数据
      getTableList() {
        this.$store.commit('setSpinShow', true)
        apiMember
          .apiPositionList({ ...this.search })
          .then(res => {
            const { data, meta } = res
            this.apiData.tableList = data
            this.apiData.per_page = meta.pagination.per_page
            this.apiData.total = meta.pagination.total
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
      // 分页
      pageChange(e) {
        this.search.page = e
        this.getTableList()
      },
      // 搜索
      searchFn() {
        this.search.page = 1
        this.getTableList()
      },
      // 清空
      clearFn() {
        this.search = {
          search: '',
          status: '',
          page: 1,
        }
        this.getTableList()
      },
      // 下载，type：1下载资料，2下载内容
      downloadFn(type,id) {
        this.$store.commit('setSpinShow',true)
        apiMember.apiPositionDownload(type,id,{
          t: new Date().getTime(),
        }).then(res => {
          downloadBlob(res)
        }).finally(() =>this.$store.commit('setSpinShow',false))
      }
    },
    mounted() {
      this.getTableList()
    },
  }
</script>

<style scoped lang="less">
  .template {
    .search {
      display: flex;
      justify-content: space-between;
    }
    .table {
      margin-top: 10px;
    }
    .filter {
      margin: 10px 0;
      display: flex;
      justify-content: left;
      align-items: center;
      padding: 6px 0 20px 0;
      flex-wrap: wrap;
      border: 1px solid rgba(237, 237, 237, 1);

      .filter-item {
        margin: 14px 0 0 20px;

        .title {
          margin-right: 10px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(74, 74, 74, 1);
          line-height: 17px;
        }
      }
    }
  }
</style>
